// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__AICSJ","footer":"ModalError_footer__21DFJ"};